import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { employeesAttendanceUpdate } from "../../../core/data/redux/employeesAttendanceSlice";
import { getEmployeeProfile } from "../../../core/data/redux/employeesSlice";
import { useDispatch, useSelector } from "react-redux";
import Toasts from "../../../core/common/toast";
import EmployeesAttendanceTable from "./attendanceTable";
import { Tabs, Modal } from "antd";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { generateOfficeMapUrl } from "../../../utils/officeMapUtils";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface EmployeesAttendanceListProps {}

const schema = Yup.object().shape({
  reason: Yup.string(),
  attendance_status: Yup.string(),
  half_day_type: Yup.string(),
});

const EmployeesAttendanceList = (props: EmployeesAttendanceListProps) => {
  const user: any = localStorage.getItem("user");
  const userJson = user && user != "undefined" ? JSON.parse(user) : {};
  const userType: any = userJson?.user_type || userJson?.role;
  const [actionType, setActionType] = useState<any>(null);
  const [dayType, setDayType] = useState<string>(""); // For reject: "FULL_DAY" or "HALF_DAY"
  const [checkinLocationMismatch, setCheckinLocationMismatch] = useState<boolean>(false);
  const [checkoutLocationMismatch, setCheckoutLocationMismatch] = useState<boolean>(false);
  const [earlyLeaving, setEarlyLeaving] = useState<boolean>(false);
  const [lateComing, setLateComing] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const location = useLocation();
  const stateFilters = location.state as any;
  const [type, setType] = useState(stateFilters?.status || "PENDING");
  const onChange = (key: string) => {
    setType(key);
  };
  const tabs: any[] = ["PENDING", "VERIFIED", "REJECTED"];

  const routes = all_routes;
  const dispatch = useDispatch();
  const [docurl, setDocurl] = useState<any>(null);
  const [currentItem, setCurrentItem] = useState<any>(null);
  const [officeData, setOfficeData] = useState<any[]>([]);
  const employeesAttendanceState = useSelector(
    (state: any) => state.employeesAttendanceState
  );
  const employeesState = useSelector((state: any) => state.employeesState);

  const handleUpdate = async () => {
    //await dispatch(employeesAttendanceUpdate({ id: currentItem.id, is_verified: 'VERIFIED' }));
    //setCurrentItem(null);
  };

  React.useEffect(() => {
    if (currentItem) {
      setValue("reason", currentItem?.reason || "");
      setValue("attendance_status", currentItem?.attendance_status || "");
      setValue("half_day_type", currentItem?.half_day_type || "");
      setDayType("");

      // Reset checkbox values for Accept action
      setCheckinLocationMismatch(false);
      setCheckoutLocationMismatch(false);
      setEarlyLeaving(false);
      setLateComing(false);
    }
  }, [currentItem]);

  const onSubmit = async (data: any, event: any) => {
    const action = event.nativeEvent.submitter.value;

    if (!actionType) {
      setError("reason", {
        type: "manual",
        message: "Please select an action type.",
      });
      return;
    }

    // Remark is required only for reject case
    if (actionType === "reject" && !data?.reason) {
      setError("reason", {
        type: "manual",
        message: "Remark is required for rejection.",
      });
      return;
    }

    if (
      actionType === "reject" &&
      dayType === "HALF_DAY" &&
      !data?.half_day_type
    ) {
      setError("half_day_type", {
        type: "manual",
        message: "Please select half day type.",
      });
      return;
    }

    const isVerified = actionType === "accept" ? "VERIFIED" : "REJECTED";

    const payload = {
      id: currentItem.id,
      is_verified: isVerified,
      regularize_remark: data?.reason ? data.reason : "",
      attendance_status: isVerified === "REJECTED" ? "ABSENT" : "PRESENT",
      half_day_type:
        actionType === "reject" && dayType === "HALF_DAY"
          ? data?.half_day_type || ""
          : "",
      location_mismatch: actionType === "accept" ? (checkinLocationMismatch || checkoutLocationMismatch) : false,
      early_leaving: actionType === "accept" ? earlyLeaving : false,
      late_coming: actionType === "accept" ? lateComing : false,
      day_type: actionType === "reject" ? dayType : "",
      checkin_location_mismatch: actionType === "accept" ? checkinLocationMismatch : false,
      checkout_location_mismatch: actionType === "accept" ? checkoutLocationMismatch : false,
      is_checkout_location_mismatch: actionType === "accept" ? checkoutLocationMismatch : false,
      checkin_face_mismatch: false,
      checkout_face_mismatch: false,
    };

    await dispatch(employeesAttendanceUpdate(payload));
    setCurrentItem(null);
    reset();
    setActionType(null);
    setDayType("");
    setCheckinLocationMismatch(false);
    setCheckoutLocationMismatch(false);
    setEarlyLeaving(false);
    setLateComing(false);
  };

  const setItem = async (item: any) => {
    setCurrentItem(item);
  };

  React.useEffect(() => {
    if (
      employeesAttendanceState.loading === "fulfilled" &&
      employeesAttendanceState.action === "get"
    ) {
      const result = employeesAttendanceState?.data?.data || null;
      setDocurl(result.url);
    }
  }, [employeesAttendanceState.loading]);

  // Fetch office data when currentItem changes
  React.useEffect(() => {
    if (currentItem) {
      const employeeId =
        currentItem?.employee_id ||
        currentItem?.employee?.id ||
        currentItem?.employee?.employee_id ||
        currentItem?.emp_id;

      if (employeeId) {
        dispatch(getEmployeeProfile({ empId: employeeId }));
      }
    }
  }, [currentItem, dispatch]);

  // Extract office data from employee profile
  React.useEffect(() => {
    if (
      employeesState?.loading === "fulfilled" &&
      employeesState?.action === "employee-profile"
    ) {
      const responseData = employeesState?.controllingOfficerData;
      const profileData =
        responseData?.data?.data || responseData?.data || responseData;

      if (
        profileData?.offices &&
        Array.isArray(profileData.offices) &&
        profileData.offices.length > 0
      ) {
        setOfficeData(profileData.offices);
      }
    }
  }, [employeesState]);

  // Generate map link
  const handleGenerateMapLink = () => {
    if (officeData.length === 0) {
      toast.error("No office data available");
      return;
    }

    try {
      // Use the first office for the map link
      const firstOffice = officeData[0];
      const lat = parseFloat(firstOffice.lat || firstOffice.latitude || "0");
      const lng = parseFloat(firstOffice.long || firstOffice.longitude || "0");
      const coordinates = firstOffice.coordinates || [];

      if (!coordinates || coordinates.length === 0) {
        toast.error("No coordinates available for this office");
        return;
      }

      const mapUrl = generateOfficeMapUrl(lat, lng, coordinates);
      navigator.clipboard.writeText(mapUrl);
      toast.success("Map link copied to clipboard!");
    } catch (error: any) {
      toast.error(`Error generating link: ${error.message}`);
    }
  };
  const attendanceStatusOptions = {
    PRESENT: "Present",
    ABSENT: "Absent",
    HALF_DAY: "Half-day",
    LATE_COMING: "Late Coming",
    EARLY_LEAVING: "Early Leaving",
    ON_LEAVE: "On Leave",
  };

  const halfDayTypeOptions = {
    FIRST_HALF: "First Half",
    SECOND_HALF: "Second Half",
    NONE: "None",
  };

  return (
    <div>
      <>
        <Toasts
          show={employeesAttendanceState.loading === "rejected"}
          message={employeesAttendanceState.error}
          title={"Failed"}
          type={"danger"}
        />
        <Toasts
          show={
            employeesAttendanceState.loading === "fulfilled" &&
            employeesAttendanceState.action == "update"
          }
          message={employeesAttendanceState?.data?.message}
          title={"Success"}
          type={"success"}
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Attendance Regularize</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Attendance Regularize</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Attendance Regularize
                    </li>
                  </ol>
                </nav>
              </div>
            </div>

            <Tabs
              activeKey={type}
              onChange={onChange}
              type="card"
              items={tabs.map((item) => {
                return {
                  label: `${item}`,
                  key: item,
                  //children: <EmployeesAttendanceTable type={type} setItem={setItem} />,
                };
              })}
            />
            <EmployeesAttendanceTable type={type} setItem={setItem} />
          </div>
        </div>
      </>

      <Modal
        title={"Approve Action"}
        open={currentItem}
        onCancel={() => {
          setCurrentItem(null);
          reset();
          setActionType(null);
          setDayType("");
          setCheckinLocationMismatch(false);
          setCheckoutLocationMismatch(false);
          setEarlyLeaving(false);
          setLateComing(false);
        }}
        footer={false}
        width={600}
      >
        <div className="row">
          <div className="col-md-6">
            {docurl ? (
              <img
                src={docurl}
                width={400}
                height={400}
                style={{ objectFit: "contain", borderRadius: "8px" }}
              />
            ) : (
              <div
                style={{
                  width: 250,
                  height: 250,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #ccc",
                }}
              >
                <i
                  className="ti ti-user"
                  style={{ fontSize: "120px", color: "#aaa" }}
                />
                <p
                  style={{ color: "#888", marginTop: "16px", fontSize: "14px" }}
                >
                  No Document Available
                </p>
              </div>
            )}
            {officeData.length > 0 && (
              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-info btn-sm"
                  onClick={handleGenerateMapLink}
                  style={{ width: "100%" }}
                >
                  <i className="ti ti-map me-2" />
                  Generate & Copy Map Link
                </button>
                <small className="text-muted d-block mt-2">
                  Click to generate and copy a shareable link for viewing office
                  locations on map
                </small>
              </div>
            )}
          </div>
          <div className="col-md-6">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label style={{ float: "left" }}>Action Type</label>
                  <select
                    className="form-control"
                    value={actionType || ""}
                    disabled={currentItem?.is_verified !== "PENDING"}
                    onChange={(e) => {
                      setActionType(e.target.value);
                      setDayType("");
                      setValue("half_day_type", "");
                      if (e.target.value === "reject") {
                        setValue("attendance_status", "ABSENT");
                      } else {
                        setValue("attendance_status", "PRESENT");
                      }
                    }}
                  >
                    <option value="">Select Option</option>
                    <option key={"accept"} value={"accept"}>
                      Accept
                    </option>
                    <option key={"reject"} value={"reject"}>
                      Reject
                    </option>
                  </select>
                </div>

                {/* Checkboxes for Accept Action */}
                {actionType === "accept" && (
                  <div className="col-md-12 mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <label style={{ float: "left", marginBottom: "8px" }}>
                        Options
                      </label>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="checkinLocationMismatch"
                          checked={checkinLocationMismatch}
                          onChange={(e) => setCheckinLocationMismatch(e.target.checked)}
                          disabled={currentItem?.is_verified !== "PENDING"}
                          style={{
                            width: "18px",
                            height: "18px",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="checkinLocationMismatch"
                          style={{ margin: 0, cursor: "pointer" }}
                        >
                          Check-in Location Mismatch
                        </label>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="checkoutLocationMismatch"
                          checked={checkoutLocationMismatch}
                          onChange={(e) => setCheckoutLocationMismatch(e.target.checked)}
                          disabled={currentItem?.is_verified !== "PENDING"}
                          style={{
                            width: "18px",
                            height: "18px",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="checkoutLocationMismatch"
                          style={{ margin: 0, cursor: "pointer" }}
                        >
                          Check-out Location Mismatch
                        </label>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="earlyLeaving"
                          checked={earlyLeaving}
                          onChange={(e) => setEarlyLeaving(e.target.checked)}
                          disabled={currentItem?.is_verified !== "PENDING"}
                          style={{
                            width: "18px",
                            height: "18px",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="earlyLeaving"
                          style={{ margin: 0, cursor: "pointer" }}
                        >
                          Early Leaving
                        </label>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="lateComing"
                          checked={lateComing}
                          onChange={(e) => setLateComing(e.target.checked)}
                          disabled={currentItem?.is_verified !== "PENDING"}
                          style={{
                            width: "18px",
                            height: "18px",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="lateComing"
                          style={{ margin: 0, cursor: "pointer" }}
                        >
                          Late Coming
                        </label>
                      </div>
                    </div>
                  </div>
                )}

                {/* Day Type Dropdown for Reject Action */}
                {actionType === "reject" && (
                  <div className="col-md-12 mb-3">
                    <label style={{ float: "left" }}>Day Type</label>
                    <select
                      className="form-control"
                      value={dayType}
                      disabled={currentItem?.is_verified !== "PENDING"}
                      onChange={(e) => {
                        setDayType(e.target.value);
                        if (e.target.value === "FULL_DAY") {
                          setValue("half_day_type", "");
                        }
                      }}
                    >
                      <option value="">Select Option</option>
                      <option value="FULL_DAY">Full Day</option>
                      <option value="HALF_DAY">Half Day</option>
                    </select>
                  </div>
                )}

                {/* Half Day Type Dropdown - Only shown when Reject + Half Day */}
                {actionType === "reject" && dayType === "HALF_DAY" && (
                  <div className="col-md-12 mb-3">
                    <label style={{ float: "left" }}>Half Day Type</label>
                    <select
                      className="form-control"
                      {...register("half_day_type")}
                      disabled={currentItem?.is_verified !== "PENDING"}
                    >
                      <option value="">Select Option</option>
                      {Object.entries(halfDayTypeOptions)
                        .filter(([key]) => key !== "NONE")
                        .map(([value, label]) => (
                          <option key={value} value={value}>
                            {label}
                          </option>
                        ))}
                    </select>
                    {errors.half_day_type && (
                      <small className="text-danger" style={{ float: "left" }}>
                        {errors.half_day_type.message}
                      </small>
                    )}
                  </div>
                )}

                {/* Reason Section */}
                <div className="col-md-12 mb-3">
                  <label style={{ float: "left" }}>
                    Remarks {actionType === "reject" && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Remarks"
                    rows={4}
                    {...register("reason")}
                    disabled={currentItem?.is_verified !== "PENDING"}
                  />
                  {errors.reason && (
                    <small className="text-danger" style={{ float: "left" }}>
                      {errors.reason.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div
                    className="modal-footer"
                    style={{ gap: 20, border: "none" }}
                  >
                    {currentItem?.is_verified === "PENDING" ? (
                      <>
                        <div className="d-flex justify-content-center">
                          {/* {userType === "EMPLOYEE" && ( */}
                            <button
                              type="submit"
                              className="btn btn-primary px-4 py-2"
                              style={{ fontSize: "16px", fontWeight: "500" }}
                              value="VERIFIED"
                              disabled={
                                !actionType ||
                                (actionType === "reject" && !dayType)
                              }
                            >
                              Regularize
                            </button>
                          {/* )} */}
                        </div>

                        {/* <button
                          type="submit"
                          className="btn btn-primary btn-sm"
                          value="REJECTED"
                          disabled={currentItem.check_out_time ? false : true}
                        >
                          Reject
                        </button> */}
                      </>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        disabled
                      >
                        {currentItem?.is_verified}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EmployeesAttendanceList;
